import { createContext, useContext } from 'react';
import type { UseControlCenterPageResult } from './useControlCenterPage';

export const ControlCenterContext =
    createContext<UseControlCenterPageResult | null>(null);

export const useControlCenter = () => {
    const context = useContext(ControlCenterContext);

    if (!context) {
        throw new Error('ControlCenterProvider is required');
    }

    return context;
};
